import React from 'react';
import { Header } from './components/site/Header';
import { Hero } from './components/site/Hero';
import { Services } from './components/site/Services';
import { WhyUs } from './components/site/WhyUs';
import { Gallery } from './components/site/Gallery';
import { Reviews } from './components/site/Reviews';
import { Contact } from './components/site/Contact';
import { Footer } from './components/site/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-background font-heading text-foreground" data-id="element-0" data-mp="2rl6un4aq0ot8">
      <Header data-id="element-1" data-mp="2mn59mdtqiff4" />
      <main data-id="element-2" data-mp="2mnng03a42a0r">
        <Hero data-id="element-3" data-mp="2mjpyfm36lqiz" />
        <Services data-id="element-4" data-mp="31aqf2ee30qq7" />
        <WhyUs data-id="element-5" data-mp="31b8lg3ugklbu" />
        <Gallery data-id="element-6" data-mp="31bs0ncsq4vm6" />
        <Reviews data-id="element-7" data-mp="31c9tdzg6grpc" />
        <Contact data-id="element-8" data-mp="31ctflscv2296" />
      </main>
      <Footer data-id="element-9" data-mp="2wka02pum4x1q" />
    </div>;
}